import {
  CustomerSearchDataFragment,
  DepartmentDataFragment,
  LegalPersonType
} from "@bonliva-crm/graphql";
import * as yup from "yup";

export type WorkExperienceFormValues = {
  areaOfExpertise?: string | null;
  roles: string;
  from: Date | null;
  to: Date | null;
  departments: DepartmentDataFragment[];
  competitors?: Array<string | null> | null;
  employmentType?: LegalPersonType | null;
  experience?: string | null;
  customer: CustomerSearchDataFragment;
  excludeFromPresentation?: boolean;
};

export const workExperienceFormSchema = yup.object({
  areaOfExpertise: yup.string().nullable(true),
  roles: yup.string(),
  from: yup.date().nullable(true),
  to: yup.date().nullable(true),
  departments: yup
    .array(yup.object({ _id: yup.string() }).noUnknown(false))
    .nullable(true),
  competitors: yup.array(yup.string()).when("employmentType", {
    is: LegalPersonType.Subcontractor,
    then: (schema) => schema.required(),
    otherwise: (schema) => schema.nullable(true)
  }),
  employmentType: yup
    .mixed()
    .oneOf([...Object.values(LegalPersonType)])
    .required(),
  experience: yup.string().nullable(true),
  customer: yup
    .object({
      _id: yup.string()
    })
    .noUnknown(false)
    .required(),
  excludeFromPresentation: yup.boolean().nullable(true)
});
